export default "/_next/static/images/78240ea50058ba38549a7fd1f20cad8d.jpg";